import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll-to-selected"
export default class extends Controller {
  connect() {
    // Find the first element with the 'selected' class
    const selectedElement = this.element.querySelector(".selected");

    // If a selected element exists, scroll it into view
    if (selectedElement) {
      // Use scrollIntoView to center the selected element in the visible area
      selectedElement.scrollIntoView({
        behavior: "auto",
        block: "center",
      });
    }
  }
}
